var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.177,
    height: 18.143,
    viewBox: "0 0 18.177 18.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    transform: "translate(23.466 23.869) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_filter_1454764",
    transform: "translate(34.466 144.219) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70960",
    "data-name": "Path 70960",
    d: "M136.977,121.721a.635.635,0,0,1-.079.3l-.032.051-6.4,8.119v5.537a.624.624,0,0,1-.311.539l-.087.043-2.348,1.358-.032.015a.618.618,0,0,1-.26.055.625.625,0,0,1-.626-.624V130.2l-6.395-8.117-.032-.051a.612.612,0,0,1-.079-.3.625.625,0,0,1,.626-.624h15.427A.62.62,0,0,1,136.977,121.721Z",
    transform: "translate(-108.549 0)",
    fill: "none",
    stroke: "#f45e29",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon_filter.f913e09a.svg";
export { ForwardRef as ReactComponent };